import { useLocation } from "react-router-dom";
import WorkspaceManage from "./workspace-manage";
import WorkspaceManageEdit from "./workspace-manage-edit";
import MemberManage from "./member-manage";
import ServiceConnectManage from "./service-connect-manage";
import MyInfo from "./my-info";
import MyInfoEdit from "./my-info-edit";
import ProtectedRoute from "ProtectedRoute";
import { adminRoles, allRoles, policyAdminRoles, superAdminRoles } from "utils/role";
import RedirectRoute from "RedirectRoute";
import Root from "pages/root";
import { useState } from "react";
import ServicePlanManagementPage from "./ServicePlanManagement/ServicePlanManagementPage";

const SettingNavigation = () => {
  const location = useLocation().pathname;
  const paths = decodeURIComponent(location).split("/");

  const [isLinkedSlack, setIsLinkedSlack] = useState<boolean>(false);

  const getPage = () => {
    switch (paths[2]) {
      case "내 정보 관리":
        if (paths[3] === "edit") {
          return <MyInfoEdit />;
        } else return <MyInfo />;
      case "워크스페이스 관리":
        if (paths[3] === "edit") {
          return <ProtectedRoute element={<WorkspaceManageEdit />} page={paths[2]} accessRoles={superAdminRoles} />;
        } else return <ProtectedRoute element={<WorkspaceManage />} page={paths[2]} accessRoles={policyAdminRoles} />;
      case "멤버 관리":
        return <ProtectedRoute element={<MemberManage />} page={paths[2]} accessRoles={adminRoles} />;
      case "서비스 연동 관리":
        return <ServiceConnectManage setIsLinkedSlack={setIsLinkedSlack} />;
      case "서비스 플랜 관리":
        return <ServicePlanManagementPage />;
      default:
        return <RedirectRoute page={`/setting/${encodeURIComponent("내 정보 관리")}`} />;
    }
  };
  return (
    <>
      <Root>{getPage()}</Root>
    </>
  );
};

export default SettingNavigation;
